var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-scenarios"},[_c('v-subtitle',{attrs:{"zh":"应用场景","en":"Application scenarios","type":"mini"}}),_c('v-scenarios',{attrs:{"data":_vm.scenariosData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }